export default "__VITE_ASSET__D6HecS2X__"